module.exports = __webpack_public_path__ + "img/products.6c879232.svg";